module.exports = __webpack_public_path__ + "static/media/milestonecheck3.8f03bf8c.svg";